import React, { ReactNode } from 'react';
import _ from 'lodash';
// import { useLocation } from 'react-router-dom'

import {
  Row,
  Col,
  Form,
  Button,
  ButtonGroup,
  Dropdown,
  DropdownButton,
} from 'react-bootstrap';
import styled from 'styled-components';
// import { up, down } from 'styled-breakpoints';

import { Checkbox, Divider, Alert } from "antd";

// Auth
// import { useAuthContext } from '../../../../v5/auth/use-auth-context.js';
import { useRouter } from '../../../../v5/auth/auth-guard.js';

// Redux
import { useDispatch } from 'react-redux';
import { RootState, AppDispatch, useTypedSelector } from '../../../../v5/utils/store.tsx';
import slice, { useFormikContext, fields, checkStatus, getId, isEdit, isCopy } from '../slice.tsx';
import { canWeightChit, isDisabledWeightChit } from '../../manage/jobs/jobTypes/slice.tsx';
import confirmSlice from '../../../components/modal/confirmSlice.tsx';
import printPreviewSlice from './printPreview/slice.tsx';
import proformaInvoiceSlice from './proformaInvoice/slice.tsx';
import recurringJobSlice from './recurringJob/slice.tsx';
import billingJobSlice from './billingJob/slice.tsx';
import weightChitSlice from './weightChit/slice.tsx';
import deleteJobSlice from './delete/slice.tsx';

// enums
import { hasPermission } from '../../../../v5/utils/utils.tsx';
import { Permissions } from '../../../../v5/utils/enums.tsx';

// components
// import MainContainer from '../../../../v5/components/container/MainContainer.jsx';

import FooterActionButtons from './FooterActionButtons.jsx';

// import { ReactComponent as XIcon } from "../../../../v5/assets/icons/smallX.svg";
import { ReactComponent as AlertTriangleIcon } from "../../../../v5/assets/icons/alert-triangle.svg";

// ----------------------------------------------------------------------

const StyledDivider: React.FC<React.ComponentProps<typeof Divider>> = styled(Divider)`
  margin: 0px 0px 0px 7px;
  background-color: var(--bs-gray-800);
`;


const Footer = (props: any) => {
  // const location = useLocation();
  const router = useRouter();
  
  const { values, errors, setValues, setFieldValue, validateForm, handleSubmit }: any = useFormikContext();

  const { isCreditLimit, isJobUpdated } = useTypedSelector((state: RootState) => state.jobFormSlice);
  // const confirmSliceState = useTypedSelector((state: RootState) => state.confirmSlice);
  const dispatch = useDispatch<AppDispatch>();

  const inputRemarksRef = React.useRef<any>(null);
  // const inputRef = React.useRef<any>(null);


  return <>
    <Row className='align-items-center justify-content-center g-8'>
      <Col xs={true} className='d-none d-md-block'></Col>
      {checkStatus(values?.statusName, ['completed']) && <Col xs={12} md={'auto'} className='text-center text-sm-end'>
        <Checkbox
          checked={values?.isSendEmail}
          onChange={async (e: any) => {
            await setFieldValue('isSendEmail', e.target.checked);
          }}
        >Do you want to resend DO to customer?</Checkbox>
      </Col>}

      <Col xs={true} className='d-none d-sm-block d-md-none'></Col>
      
      {isJobUpdated && <Col xs={'auto'}>
        <span className='pe-8'>Job has been updated in the mobile app.</span>
        <Button
          variant={'custom-secondary'}
          size={'sm'}
          onClick={(e: any) => {
            e.stopPropagation();
            e.preventDefault();
            
            router.reload();
          }}
        >
          Refresh Job
        </Button>
      </Col>}

      <Col xs={'auto'}>
        <DropdownButton
          variant={'custom-outlined'}
          size={'sm'}
          title={<>Options <StyledDivider type='vertical' /></>}
          disabled={!(values.customerId && values.jobTemplateId)}
        >
          {(hasPermission(Permissions.JobProofOfDelivery)) && <Dropdown.Item
            active={false}
            disabled={false}
            onClick={() => {
              dispatch(printPreviewSlice.setShow({ show: true, form: values }));
            }}
          >Print Preview</Dropdown.Item>}

          {/* {(!checkStatus(values?.statusName, ['cancelled', 'failed', 'rejected']) && (isEdit() && !isCopy())) && <Dropdown.Item
            active={false}
            disabled={false}
            onClick={() => {
              dispatch(proformaInvoiceSlice.setShow({ show: true, form: values }));
            }}
          >Proforma Invoice</Dropdown.Item>} */}

          {/* <Dropdown.Item
            active={false}
            disabled={false}
            onClick={() => {
              dispatch(recurringJobSlice.setShow(true));
            }}
          >Make Recurring</Dropdown.Item> */}

          {(hasPermission(Permissions.JobBilling)) && <Dropdown.Item
            active={false}
            disabled={false}
            onClick={() => {
              dispatch(billingJobSlice.setShow({ show: true, form: values }));
            }}
          >Bill Job</Dropdown.Item>}
          
          {(canWeightChit(values?.stepGroups) && !isDisabledWeightChit(values?.stepGroups)) && <Dropdown.Item
            active={false}
            disabled={false}
            onClick={() => {
              dispatch(weightChitSlice.setShow({ show: true, details: values }));
            }}
          >Weight Chit</Dropdown.Item>}

          {(isEdit() && !isCopy()) && <Dropdown.Item
            active={false}
            disabled={false}
            onClick={() => {
              dispatch(slice.callDetailsApi(getId(), (state: boolean, data: any) => {
                if(state){
                  router.changeParamsInUrl('id=' + getId() + '&isCopy=true');
                }
              }));
            }}
          >Copy Job</Dropdown.Item>}

          {(isEdit() && !isCopy()) && <Dropdown.Item
            className={'text-danger'}
            active={false}
            disabled={false}
            onClick={() => {
              dispatch(deleteJobSlice.setShow({ show: true }));
            }}
          >Delete Job</Dropdown.Item>}
        </DropdownButton>
      </Col>

      {!isCreditLimit && <Col xs={'auto'}>
        <FooterActionButtons 
          onSave={(eventKey: any) => {
            // dispatch(confirmSlice.show(() => {
            //   dispatch(confirmSlice.setHide());

            //   dispatch(confirmSlice.show(null, {
            //     title: 'Save as New Template',
            //     body: <>
            //       <Form.Group>
            //         <Form.Control
            //           ref={inputRef}
            //           type={'text'}
            //           autoComplete='off'
            //           autoFocus
            //           placeholder={'Enter the template name'}
            //           disabled={false}
            //         />
            //         <Form.Control.Feedback type="invalid">You must enter a template name</Form.Control.Feedback>
            //       </Form.Group>
            //     </>,
            //     size: 'md',
            //     cancelText: 'Cancel',
            //     cancelVariant: 'custom-outlined',
            //     cancelCallback: () => {
            //       // ("Cancel BUT OK");
            //     },
            //     confirmText: 'Confirm Save',
            //     confirmVariant: 'custom-primary',
            //     confirmCallback: () => {
            //       if(inputRef && inputRef.current){
            //         if(inputRef.current.value !== ''){
            //           inputRef.current.classList.remove("is-invalid");
            //           // ("Confirm BUT OK", inputRef.current.value);
            //           dispatch(confirmSlice.setHide());
            //         } else {
            //           inputRef.current.classList.add("is-invalid");
            //         }
            //       }
            //     },
            //   }));
            // }, {
            //   title: 'Custom Job Detected',
            //   body: 'Do you want save it as a new Template?',
            //   size: 'md',
            //   cancelText: 'No, thanks',
            //   cancelVariant: 'custom-outlined',
            //   cancelCallback: () => {
            //     // ("Cancel BUT OK");
            //   },
            //   confirmText: 'Save Template',
            //   confirmVariant: 'custom-primary',
            // }));

            if(props.onSave){
              props.onSave(eventKey);
            }
          }}
          onSaveCopyDraft={(eventKey: any) => {
            if(props.onSaveCopyDraft){
              props.onSaveCopyDraft(eventKey);
            }
          }}
        />
      </Col>}
    </Row>
  </>
}

export default Footer;
